export default __webpack_public_path__ + "static/media/puma-m.a688887f.jpg";